// components
import Button from '@drivesally/sally-ui/lib/components/Button/Button';
import Icon from '@drivesally/sally-ui/lib/components/Icon/Icon';

// layout components
import CompactDataRow from '../../../layout/components/CompactDataRow/CompactDataRow';
import CompactLabel from '../../../layout/components/CompactLabel/CompactLabel';
import StepFooter from '../../../layout/components/StepFooter/StepFooter';

// local components
import AddRequirement from './components/AddRequirement';
import Attribute from './components/Attribute';
import GroupAttribute from './components/GroupAttribute';
import States from './components/States';

// local lib
import getAttributeName from './lib/getAttributeName.lib';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Fragment} from 'react';

const requirementKey = (requirement) =>
  Array.isArray(requirement) ? requirement.join('|') : requirement;

const BranchRequirementsStep = ({
  attributes,
  Container,
  onBack,
  onAdd,
  onAddGroup,
  onRemove,
  onNext,
}) => (
  <Fragment>
    <Container padding="none" noBorder>
      {attributes.map((attribute) => (
        <Fragment key={attribute.key}>
          <CompactLabel>{attribute.label}</CompactLabel>
          {attribute.states.map((state) => (
            <CompactDataRow key={state.key} label={state.label} noPadding>
              {!!state.attributes.length && (
                <States>
                  {state.attributes.map((stateAttribute, index) => {
                    const isGroup = Array.isArray(stateAttribute);
                    const AttributeComponent = isGroup
                      ? GroupAttribute
                      : Attribute;
                    return (
                      <AttributeComponent
                        key={requirementKey(stateAttribute)}
                        onClick={onRemove({
                          object: attribute.key,
                          state: state.key,
                          index,
                        })}
                      >
                        {getAttributeName({
                          attributes: attribute.attributes,
                          attribute: stateAttribute,
                        })}
                        <Icon icon="close" />
                      </AttributeComponent>
                    );
                  })}
                </States>
              )}
              <AddRequirement
                options={attribute.attributes}
                onAdd={(selectedAttribute) =>
                  onAdd({
                    object: attribute.key,
                    state: state.key,
                    attribute: selectedAttribute,
                  })()
                }
                onAddGroup={(selectedAttributes) =>
                  onAddGroup({
                    object: attribute.key,
                    state: state.key,
                    attributes: selectedAttributes,
                  })()
                }
              />
            </CompactDataRow>
          ))}
        </Fragment>
      ))}
    </Container>
    <Container>
      <StepFooter
        left={
          <Button size="small" theme="grey" onClick={onBack}>
            Back
          </Button>
        }
        right={
          <Button size="small" theme="grey" onClick={onNext}>
            Next
          </Button>
        }
      />
    </Container>
  </Fragment>
);

BranchRequirementsStep.propTypes = {
  attributes: PropTypes.array,
  Container: PropTypes.any,
  onBack: PropTypes.func,
  onAdd: PropTypes.func,
  onAddGroup: PropTypes.func,
  onRemove: PropTypes.func,
  onNext: PropTypes.func,
};

export default BranchRequirementsStep;
